<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="trophy-fill" class="mr-2"></b-icon>Top mahsulot va xizmatlar</h2>
        </div>
        <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>TOP soni</label>
          <select v-model.number="limit" @change="fetch">
            <option :value="10">10</option><option :value="20">20</option>
            <option :value="50">50</option><option :value="100">100</option>
          </select>
        </div>
      </div>

      <div class="rp-2col">
        <!-- TOP MAHSULOTLAR -->
        <div class="rp-section">
          <h3 class="rp-block-title"><b-icon icon="box-seam-fill"></b-icon> TOP {{ limit }} mahsulot (sotuv soni bo'yicha)</h3>
          <div class="rp-table-wrap">
            <table class="rp-table">
              <thead>
                <tr>
                  <th class="t-center">№</th><th>Mahsulot</th>
                  <th class="t-center">Sotuv soni</th>
                  <th class="t-right">Jami daromad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in topProducts" :key="r.id">
                  <td class="t-center">
                    <span class="rp-rank" :class="rankClass(i)">{{ i + 1 }}</span>
                  </td>
                  <td class="rp-strong">{{ r.name || r.short_name }}</td>
                  <td class="t-center"><span class="rp-badge rp-badge-blue">{{ fmt(r.sold_count) }}</span></td>
                  <td class="t-right rp-green rp-strong">{{ fmt(r.sold_revenue) }}</td>
                </tr>
                <tr v-if="!loading && topProducts.length === 0"><td colspan="4" class="rp-empty">Ma'lumot yo'q</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- TOP XIZMATLAR -->
        <div class="rp-section">
          <h3 class="rp-block-title"><b-icon icon="gear-fill"></b-icon> TOP {{ limit }} xizmat (sotuv soni bo'yicha)</h3>
          <div class="rp-table-wrap">
            <table class="rp-table">
              <thead>
                <tr>
                  <th class="t-center">№</th><th>Xizmat</th>
                  <th class="t-center">Sotuv soni</th>
                  <th class="t-right">Jami daromad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in topServices" :key="r.id">
                  <td class="t-center">
                    <span class="rp-rank" :class="rankClass(i)">{{ i + 1 }}</span>
                  </td>
                  <td class="rp-strong">{{ r.name }}</td>
                  <td class="t-center"><span class="rp-badge rp-badge-purple">{{ r.sale_count }}</span></td>
                  <td class="t-right rp-green rp-strong">{{ fmt(r.revenue) }}</td>
                </tr>
                <tr v-if="!loading && topServices.length === 0"><td colspan="4" class="rp-empty">Ma'lumot yo'q</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- BAR CHARTS -->
      <div class="rp-chart-wrap" v-if="topProducts.length > 0">
        <h3 class="rp-block-title"><b-icon icon="bar-chart-line-fill"></b-icon> TOP {{ Math.min(10, topProducts.length) }} mahsulot diagrammasi</h3>
        <apexchart type="bar" height="320" :options="productChartOpts" :series="productChartSeries"></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, limit: 20,
      skladList: [], topProducts: [], topServices: [], loading: false,
    };
  },
  computed: {
    productChartOpts() {
      const top10 = this.topProducts.slice(0, 10);
      return {
        chart: { toolbar: { show: false }, fontFamily: 'inherit' },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, distributed: true } },
        colors: ['#a142f4', '#10b981', '#2563eb', '#f59e0b', '#06b6d4', '#e11d48', '#6366f1', '#84cc16', '#ec4899', '#0891b2'],
        xaxis: { categories: top10.map(p => (p.name || p.short_name || '').slice(0, 30)) },
        dataLabels: { enabled: false },
        legend: { show: false },
        tooltip: { y: { formatter: v => this.fmt(v) + " so'm" } },
        grid: { borderColor: '#f1f5f9' },
      };
    },
    productChartSeries() {
      return [{ name: 'Daromad', data: this.topProducts.slice(0, 10).map(p => parseFloat(p.sold_revenue) || 0) }];
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    rankClass(i) { if (i === 0) return 'rp-rank-gold'; if (i === 1) return 'rp-rank-silver'; if (i === 2) return 'rp-rank-bronze'; return ''; },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/top/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null, limit: this.limit,
        });
        this.topProducts = r.data.top_products || [];
        this.topServices = r.data.top_services || [];
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.rp-rank {
  display: inline-block; width: 28px; height: 28px; line-height: 28px;
  border-radius: 50%; background: #f1f5f9; color: #64748b;
  font-weight: 800; font-size: 12px;
}
.rp-rank-gold { background: linear-gradient(135deg, #fbbf24, #d97706); color: white; box-shadow: 0 2px 8px rgba(217, 119, 6, 0.3); }
.rp-rank-silver { background: linear-gradient(135deg, #cbd5e1, #94a3b8); color: white; }
.rp-rank-bronze { background: linear-gradient(135deg, #d97706, #92400e); color: white; }
</style>
